import { useSyncExternalStore } from 'react';

const eventName = 'dexa:navigate';

export type WorkspaceMode = 'seller' | 'buyer';

export function workspaceMode(params: URLSearchParams): WorkspaceMode {
    return params.get('workspace') === 'buyer' ? 'buyer' : 'seller';
}

function subscribe(callback: () => void) {
    window.addEventListener('popstate', callback);
    window.addEventListener(eventName, callback);
    return () => {
        window.removeEventListener('popstate', callback);
        window.removeEventListener(eventName, callback);
    };
}
function snapshot() { return window.location.pathname + window.location.search; }
export function navigate(href: string, replace = false) {
    const url = new URL(href, window.location.origin);
    if (url.origin !== window.location.origin) throw new Error('Application navigation must stay on the same origin.');
    window.history[replace ? 'replaceState' : 'pushState']({}, '', url.pathname + url.search);
    window.dispatchEvent(new Event(eventName));
}
export function useNavigation() {
    const current = useSyncExternalStore(subscribe, snapshot, () => '/overview');
    const [path, search = ''] = current.split('?');
    const params = new URLSearchParams(search);
    function href(target: string, updates: Record<string, string | null> = {}) {
        const next = new URLSearchParams();
        for (const key of ['property', 'workspace']) {
            const value = params.get(key);
            if (value) next.set(key, value);
        }
        for (const [key, value] of Object.entries(updates)) if (value !== null && value !== '') next.set(key, value);
        return target + (next.size ? `?${next}` : '');
    }
    function update(updates: Record<string, string | null>, replace = false) {
        const next = new URLSearchParams(search);
        for (const [key, value] of Object.entries(updates)) {
            if (value === null || value === '') next.delete(key); else next.set(key, value);
        }
        navigate(path + (next.size ? `?${next}` : ''), replace);
    }
    return { path, params, href, update, navigate };
}
